<div class="pv20">
  <p class="logout-modal-message">
    {{ "AreYouSureYouWantToLogOut" | translate }}
  </p>
  <div class="logout-modal-alert-message" *ngIf="myAvailabilityCount > 0">
    <p class="pt8">
      {{ "AttentionYouAreAvailable" | translate : {count: myAvailabilityCount} }}
    </p>
    <p class="pt8">
      {{ "IfYouDoNotWantToReceiveRequests" | translate }}
    </p>
  </div>
</div>

<div class="text-right border pv10">
  <button nz-button (click)="cancel()">{{ 'Cancel' | translate}}</button>
  <button nz-button class="ml10 mr16" (click)="logout()" [nzLoading]="isLoading" nzType="primary">{{ 'LogOut' |
    translate}}</button>
</div>